import { DOMHelper } from "./helpers/dom-helper";
import { MarketingClientDataLayer } from "./marketing-client-datalayer";
import { MarketingClientConstants } from "./constants/marketing-client-constants";
import { MarketingClientAttributesConstants } from "./constants/marketing-client-attributes-constants";
import { CtaObject, CollectionIdsObject, Utils } from "./utils/utils";
import { BigData } from "./marketing-client-bigdata";
import { BigDataEventConstants } from "./constants/big-data-constants";
import { MarketingClientCustomDataLayerConstants } from "./constants/marketing-client-custom-data-layer-constants";

export class MarketingClientCustomDataLayer extends MarketingClientDataLayer {
    private windowHeight = 0;
    dmElements: Array<DmElements> = new Array<DmElements>();

    init() {
        this.windowHeight = window.innerHeight;

        this.prepareDMElements();
        this.onDisplay();
        this.onScroll();
    }

    prepareDMElements() {
        DOMHelper.querySelectorAsArray(`[${MarketingClientConstants.placeholderDataSetAttribute}]`).forEach(domElement => {
            const element = domElement as HTMLElement,
                templateId = element.getAttribute(MarketingClientConstants.placeholderDataSetAttribute) || "",
                isSwimmerAttribute = element.getAttribute(MarketingClientAttributesConstants.isSwimmer),
                isDDBoxAttribute = element.getAttribute(MarketingClientAttributesConstants.isDDBox),
                isDDBox = Utils.stringNotEmpty(isDDBoxAttribute) && isDDBoxAttribute === "true",
                isSwimmer = Utils.stringNotEmpty(isSwimmerAttribute) && isSwimmerAttribute === "true",
                ctaObject: CtaObject = Utils.prepareCtaObject(element),
                collectionIdsObject: CollectionIdsObject = Utils.prepareCollectionIdsObject(element);

            if (!isDDBox) {
                this.dmElements.push({ element, templateId, isSwimmer, ctaObject, collectionIdsObject, visible: false });
            }
        });
    }

    onDisplay() {
        this.dmElements.forEach((dmElement) => {
            const dmElementIsSwimmerAndIsVisible = dmElement.isSwimmer
                && DOMHelper.elementIsVisible(dmElement.element)
                && dmElement.element.innerHTML !== "",
                dmElementIsVisibleByUser = DOMHelper.elementIsVisible(dmElement.element) && dmElement.element.offsetTop <= this.windowHeight,
                { cta = "", ctaCategory = "" } = dmElement.ctaObject;

            if (dmElementIsSwimmerAndIsVisible || dmElementIsVisibleByUser) {
                dmElement.visible = true;

                MarketingClientCustomDataLayer.sendDMEvent(ctaCategory, cta);
                // BigData.sendDataOceanEvent(BigDataEventConstants.onDisplay, { ...dmElement.ctaObject, ...dmElement.collectionIdsObject });
            }
        });
    }

    onScroll() {
        window.onscroll = this.sendEventOnScroll.bind(this);
    }

    sendEventOnScroll() {
        const scroll = window.scrollY || 0;

        this.dmElements.forEach(dmElement => {
            if (dmElement.element.offsetTop
                && scroll + this.windowHeight * 0.7 >= dmElement.element.offsetTop
                && !dmElement.visible
                && dmElement.element.innerHTML !== "") {
                const { cta = "", ctaCategory = "" } = dmElement.ctaObject;

                dmElement.visible = true;

                MarketingClientCustomDataLayer.sendDMEvent(ctaCategory, cta);
                // BigData.sendDataOceanEvent(BigDataEventConstants.onDisplay, { ...dmElement.ctaObject, ...dmElement.collectionIdsObject });
            }
        });
    }

    static sendDMEvent(category: string, message: string) {
        const customDataLayer = window[MarketingClientCustomDataLayerConstants.customDataLayer] || {};

        if (typeof customDataLayer.zajawkaDMEvent === "function") {
            customDataLayer.zajawkaDMEvent({
                category, action: MarketingClientCustomDataLayerConstants.displayAttribute, message
            });
        }
    }
}

export const marketingClientCustomDataLayer = new MarketingClientCustomDataLayer();
marketingClientCustomDataLayer.init();

interface DmElements {
    element: HTMLElement;
    templateId: string;
    isSwimmer: boolean;
    ctaObject: CtaObject;
    collectionIdsObject: CollectionIdsObject;
    visible: boolean;
}
